import React from 'react';
import ReactDOM from 'react-dom';
import Wireframe from '../../../common/js/common/webpack/Wireframe';

import Manager from './Manager.mobile';

const wireframe = new Wireframe();
wireframe.hideBubble();
wireframe.initMobile();

const legacyReactDOM = ReactDOM as unknown as {
    render: (element: React.ReactNode, container: Element | DocumentFragment | null) => void;
};

legacyReactDOM.render(
    <Manager
        leads={window.mobileManager.leads}
        formDefinition={window.mobileManager.formDefinition}
        infoTexts={window.mobileManager.infoTexts}
        isAnonymous={window.isAnonymous}
        loginUrl={window.loginUrl}
        debugCookie={window.debugCookie}
        backUrl={window.backUrl}
    />,
    document.getElementById('app'),
);
